import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLang } from "./LangContext";

export default function Hero() {
  const { t } = useLang();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="accueil" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      <video
        data-testid="hero-video"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/hero.mp4" type="video/mp4" />
      </video>

      <div className="hero-video-overlay absolute inset-0 z-10" />

      <div className="relative z-20 flex flex-col items-center justify-center h-full text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1
            data-testid="hero-title"
            className="font-bold text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-tight tracking-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            {t.hero.title1}
            <br />
            <span className="text-[#73B5E2]">{t.hero.title2}</span>
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-6 text-white/80 text-base md:text-lg max-w-2xl"
          data-testid="hero-subtitle"
        >
          {t.hero.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#portfolio"
            data-testid="hero-cta-portfolio"
            onClick={scrollTo("#portfolio")}
            className="bg-[#73B5E2] text-white hover:bg-[#5AA0D0] rounded-full px-8 py-4 text-base font-medium transition-all hover:scale-105 shadow-lg shadow-blue-500/20 text-center"
          >
            {t.hero.cta1}
          </a>
          <a
            href="#contact"
            data-testid="hero-cta-contact"
            onClick={scrollTo("#contact")}
            className="border-2 border-white text-white hover:bg-white hover:text-slate-900 rounded-full px-8 py-3 transition-all font-medium text-center flex items-center justify-center"
          >
            {t.hero.cta2}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
          className="absolute bottom-10"
        >
          <a href="#apropos" onClick={scrollTo("#apropos")}>
            <ChevronDown className="text-white/60 animate-bounce" size={32} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
